@if (route !== undefined) {
  @if (value !== undefined) {
    <portal-link [params]="routeParams" [route]="route" [value]="value"></portal-link>
  } @else {
    ...
  }
} @else {
  {{ value }}
}
